module.exports = __webpack_public_path__ + "img/4.26327296.jpg";